import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=3e8c9a6a&scoped=true"
import script from "./_footer.vue?vue&type=script&lang=js"
export * from "./_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c9a6a",
  null
  
)

export default component.exports